import { z } from "zod";
import MessageContent from "notifications/values/message-content/message-content";
import { parseOrThrow } from '_shared/_utilities/zod-schema-parser';

export type MessageContentJSON = z.infer<typeof MessageContentSchema.MessageContentJSONZ>;
export type MessageContentParams = z.infer<typeof MessageContentSchema.MessageContentZ>;

export default class MessageContentSchema {
  public static readonly MessageContentJSONZ = z.string();
  public static readonly MessageContentZ = z.custom<MessageContent>(
    (data) => data instanceof MessageContent,
    "Not a valid MessageContent instance"
  );

 public static validateJSON(values: unknown): MessageContentParams {
    return parseOrThrow(
      MessageContentSchema.MessageContentZ,
      values,
      { 
        logError: true,
        schemaName: "MessageContentSchema",
        operation: "validateJSON",
        payloadSample: values 
      }
    );
  }

  public static isValidJSON(values: unknown): values is MessageContentParams {
    try {
      MessageContentSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: MessageContentJSON): MessageContentParams {
    const parsed = parseOrThrow(
      MessageContentSchema.MessageContentJSONZ,
      data,
      { 
        logError: true,
        schemaName: "MessageContentSchema",
        operation: "deserialize",
        payloadSample: data 
      }
    );
    return MessageContentSchema.codec.decode(parsed);
  }

  public static serialize(data: MessageContentParams): MessageContentJSON {
    const parsed = MessageContentSchema.validateJSON(data);
    return MessageContentSchema.codec.encode(parsed);
  }

  public static readonly codec = z.codec(
    MessageContentSchema.MessageContentJSONZ,
    MessageContentSchema.MessageContentZ, {
    decode: (data) => new MessageContent(data),
    encode: (messageContent) => messageContent.value
  });
}
